'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _toArray2 = require('babel-runtime/helpers/toArray');

var _toArray3 = _interopRequireDefault(_toArray2);

var _enhanceReducer = require('./enhanceReducer');

var _enhanceReducer2 = _interopRequireDefault(_enhanceReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates enhanced store factory, which takes original `createStore` as argument.
 * Returns modified store which is capable of handling Reducers in form of Generators.
 *
 * @param {Function} Original createStore implementation to be enhanced
 * @returns {Function} Store factory
 */

exports.default = function (createStore) {
  return function (rootReducer, initialState) {
    var store = null;
    var executeEffects = false; // Flag to indicate whether it's allowed to execute effects
    var wrappedDispatch = null;

    var callWithEffects = function callWithEffects(fn) {
      executeEffects = true;
      var result = fn();
      executeEffects = false;
      return result;
    };

    var deferEffects = function deferEffects(effects) {
      if (executeEffects) {
        setTimeout(function () {
          if (wrappedDispatch) {
            effects.forEach(function (_ref) {
              var _ref2 = (0, _toArray3.default)(_ref);

              var fn = _ref2[0];

              var args = _ref2.slice(1);

              return fn.apply(undefined, [wrappedDispatch].concat((0, _toConsumableArray3.default)(args)));
            });
          } else {
            // In case anyone tries to do some magic with `setTimeout` while creating store
            console.warn('There\'s been attempt to execute effects yet proper creating of store has not been finished yet');
          }
        }, 0);
      }
    };

    // createStore dispatches @@INIT action and want this action to be dispatched
    // with effects too
    callWithEffects(function () {
      store = createStore((0, _enhanceReducer2.default)(rootReducer, deferEffects), initialState);
    });

    // only wrapped dispatch executes effects
    // that ensures that for example devtools do not execute effects while replaying
    wrappedDispatch = function wrappedDispatch() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return callWithEffects(function () {
        var _store;

        return (_store = store).dispatch.apply(_store, args);
      });
    };

    return (0, _extends3.default)({}, store, {
      dispatch: wrappedDispatch,
      replaceReducer: function replaceReducer(nextReducer) {
        store.replaceReducer((0, _enhanceReducer2.default)(nextReducer, deferEffects));
      }
    });
  };
};